var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCoupleNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: props.color
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.136 15.814l-.68-.68a1.257 1.257 0 00-.772-.32H9.236c-.25 0-.596.144-.772.32l-.68.68-2.542 2.542a.955.955 0 00-.177 1.102.93.93 0 00.177.252.93.93 0 00.252.178.957.957 0 001.103-.178l1.867-1.866c.176-.176.318-.116.318.133v3.325c0 .214.155.387.356.432v.02h3.643v-.02a.446.446 0 00.355-.432v-3.325c0-.25.144-.31.32-.133l1.866 1.866a.956.956 0 001.104.176.91.91 0 00.428-.428.957.957 0 00-.177-1.102l-2.541-2.542zM12.225 14.142c.45-.477.672-.883.672-1.957a1.86 1.86 0 00-1.937-1.938 1.862 1.862 0 00-1.939 1.938c0 1.074.223 1.48.672 1.957.412.301.851.343 1.267.343.415 0 .853-.042 1.265-.343"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.216 15.814l-.68-.68a1.257 1.257 0 00-.772-.32h-3.448c-.249 0-.596.144-.772.32l-.68.68-2.54 2.542h-.002a.955.955 0 00-.176 1.102.93.93 0 00.177.252.93.93 0 00.252.178.957.957 0 001.103-.178l1.866-1.866c.176-.176.32-.116.32.133v3.325c0 .214.154.387.355.432v.02h3.643v-.02a.446.446 0 00.354-.432v-3.325c0-.25.144-.31.32-.133l1.867 1.866a.956.956 0 001.104.176.91.91 0 00.428-.428.957.957 0 00-.177-1.102l-2.542-2.542zM22.306 14.142c.45-.477.672-.883.672-1.957a1.86 1.86 0 00-1.937-1.938 1.862 1.862 0 00-1.939 1.938c0 1.074.223 1.48.672 1.957.412.301.85.343 1.267.343.415 0 .853-.042 1.265-.343"
  })))));
}

export default SvgIconCoupleNew;